import { createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css'

import { mixins } from "@/plugins/mixins";
export default {
  name: "faultInfo",
  mixins: [mixins],
  components: {},
  data() {
    return {
      switchLoading: false,
      currentId: null,
      detailDrawer: false,
      columns: [{
        label: '故障类型名称',
        prop: 'name'
      }, {
        label: '故障类型状态',
        customRender: props => {
          if (this.$hasPermission('user_enable')) {
            return _createVNode(_resolveComponent("el-switch"), {
              "modelValue": props.row.status,
              "onUpdate:modelValue": $event => props.row.status = $event,
              "loading": this.switchLoading,
              "before-change": () => {
                return new Promise((resolve, reject) => {
                  this.changeEnabled(props.row, resolve, reject);
                });
              }
            }, null);
          } else {
            return props.row.status ? '使用中' : '已禁用';
          }
        }
      }],
      topButtons: [{
        name: '新增',
        code: 'faultInfo_add',
        type: 'primary',
        click: this.add,
        permissions: ['faultInfo_add']
      }],
      linkButtons: [{
        name: '编辑',
        code: 'faultInfo_edit',
        click: this.edit,
        permissions: ['dictionary_edit']
      }],
      searchItems: [{
        prop: 'name',
        label: '故障名称'
      }]
    };
  },
  methods: {
    changeEnabled(info, resolve, reject) {
      this.switchLoading = true;
      const callBack = res => {
        if (res.code === 200) {
          ElMessage({
            message: res.message,
            type: 'success'
          });
          return resolve(true);
        } else {
          ElMessage.error(res.message);
          return reject(new Error('Error'));
        }
      };
      if (info.status) {
        this.$api.business.faultInfo.disable({
          id: info.id
        }).then(callBack).finally(() => this.switchLoading = false);
      } else {
        this.$api.business.faultInfo.enable({
          id: info.id
        }).then(callBack).finally(() => this.switchLoading = false);
      }
    },
    add() {
      this.$router.push('/faultInfoAdd');
    },
    edit(row) {
      this.$router.push({
        path: '/faultInfoAdd',
        query: {
          id: row.id
        }
      });
    }
  }
};